import { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const MaskContext = createContext({ masked: false, toggleMask: () => {} });

export const useMask = () => useContext(MaskContext);

/** Hassas değeri gizle — isim/firma adı */
export const mn = (val, masked) => masked ? '**********' : val;

/** Hassas değeri gizle — tutar/para */
export const mm = (val, masked) => masked ? '***' : val;

export const MaskProvider = ({ children }) => {
  const [masked, setMasked] = useState(false);
  const location = useLocation();

  // Sayfa değişince mask kapat
  useEffect(() => { setMasked(false); }, [location.pathname]);

  const toggleMask = useCallback(() => setMasked(p => !p), []);

  return (
    <MaskContext.Provider value={{ masked, toggleMask }}>
      {children}
    </MaskContext.Provider>
  );
};

export default MaskContext;
